import React, { Component, PropTypes } from 'react';
import './Guide.css';

class Guide extends Component {
  render() {
    const previewImage =  this.props.companyFields 
                            ? this.props.companyFields.logo.value.preview
                                        ? this.props.companyFields.logo.value.preview
                                        : this.props.companyFields.logo.fileName 
                            : null;
    const colors = this.props.companyFields && this.props.companyFields.primary_color.value;
      
    return (
      <div>
        <h3 className="guide__header">{this.props.header}</h3>
        {previewImage 
            ? <img className="guide__image" src={previewImage} />
            : this.props.placeholder 
                ? <div><img className="guide__image placeholder" src="https://s3-us-west-2.amazonaws.com/cinch-dev-logos/default/default.png" /><p className="guide__paragraph">Please upload an image.</p></div>
                : null
        }
        {colors
         ? this.renderColorBoxes()                
         :this.props.message.map((mes) => {
            return (
              <p className="guide__paragraph">
                {mes}
              </p>
            )
          })
        }
      </div>
    );
  }
  renderColorBoxes(){
      return(
          <div className="color-boxes">
            <div className="primary" style={{backgroundColor:this.props.companyFields.primary_color.value}} />
            <div className="secondary" style={{backgroundColor:this.props.companyFields.secondary_color.value}} />
          </div>
      );
  }
}

Guide.propTypes = {
  message: PropTypes.string,
  header: PropTypes.string
};

export default Guide;



/** WEBPACK FOOTER **
 ** ./src/components/Guide/index.js
 **/